import React from 'react';
import { compose } from 'recompose';
import {
  Divider,
  Segment,
  Grid,
} from 'semantic-ui-react';
import ThemeSelector from '../../themes/theme-selector';
import withIntercom from '../../hocs/with-guest-intercom';

const theme = ThemeSelector.theme();

const logoStyle = {
  display: 'block',
  margin: '50px auto 30px auto',
  maxWidth: '100%',
};

const TokenThanks = () => {
  if (theme.tokenThanksRedirectUrl) {
    console.log('TokenThanks', theme.tokenThanksRedirectUrl);
    window.location = theme.tokenThanksRedirectUrl;
  }
  return (
    <div className="page">
      <div className="page-content">
        <a href="/"><img style={logoStyle} src={theme.darkLogo.src} alt={theme.darkLogo.alt} /></a>
        <Grid container>
          <Grid.Row>
            <Grid.Column only="computer" computer="3" />
            <Grid.Column computer="10" mobile="16">
              <Segment textAlign="center" size="small">
                {!theme.tokenThanksMessage &&
                (<h1 style={{ textAlign: 'center' }}>
              Thanks!<br />We will process your token directly...
                </h1>) }
                {theme.tokenThanksMessage &&
                (<h1 style={{ textAlign: 'center' }}>
                  {theme.tokenThanksMessage}
                </h1>) }
                {!theme.tokenThanksMessage && <Divider />}
                {!theme.tokenThanksMessage &&
                <p className="info">Our support team will be in touch if there are any issues.</p>}
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Column only="computer" computer="3" />
        </Grid>
      </div>
    </div>
  );
};


export default compose(withIntercom)(TokenThanks);



/** WEBPACK FOOTER **
 ** ./src/components/token-thanks/index.js
 **/